<template>
  <div class="main-wrap">
    <!-- 渠道客户独有 -->
    <van-row class="customerCredit-x" type="flex" v-if="this.title.quota_switch">
      <div id="progress-container">
        <van-row class="progress-detail">
          <van-row ref="money" class="money" :style="{ fontSize: moneyFontSize }">{{ title.can_use_quota }}</van-row>
          <van-divider />
          <van-row class="label">可用额度</van-row>
          <van-row class="title">信誉额度</van-row>
        </van-row>
      </div>
      <div class="credit-detail-x">
        <van-image class="wave-img" :src="waveUrl" />
        <van-row class="credit-li" type="flex" justify="space-bett">
          <van-col class="credit-ul" :span="8">
            <div>￥{{ this.title.quota }}</div>
            <div class="ft-12">{{ "固定额度" }}</div>
          </van-col>
          <van-col class="credit-ul" :span="8">
            <div>￥{{ this.title.temporary_quota }}</div>
            <div class="ft-12">{{ "临时额度" }}</div>
          </van-col>
          <van-col class="credit-ul" :span="8">
            <div>￥{{ this.title.have_used_quota }}</div>
            <div class="ft-12">{{ "已使用额度" }}</div>
          </van-col>
        </van-row>
      </div>
      <div class="credit-up" @click="showCreditUpHandle">申请提升额度</div>
    </van-row>
    <!-- 头部信息区域 start -->
    <div class="header-info">
      <div class="header-bg"></div>
      <div class="container">
        <div class="top">
          <div class="supplier-wrap">
            <div class="abbreviation">{{ title.abbreviation }}</div>
            <div class="fullName">{{ title.name }}</div>
          </div>
          <van-button class="bt-info" round color="#51596e" size="small" @click="showSupplierInofHandle">
            客户详情</van-button
          >
        </div>
        <div class="bottom">
          <van-row class="card-wrap">
            <van-col :span="8" @click="showPopupHandle">
              <div class="yellow">￥{{ title.thismounthsubsist }}</div>
              <div class="label">{{ "本月应收账款" }}</div>
            </van-col>
            <van-col :span="8">
              <div class="yellow">￥{{ title.totalsubsist }}</div>
              <div class="label">{{ "总应收账款" }}</div>
            </van-col>
            <van-col :span="8">
              <div class="yellow">￥{{ title.currencyamount }}</div>
              <div class="label">{{ "总租赁额" }}</div>
            </van-col>
          </van-row>
        </div>
      </div>
    </div>
    <!-- 头部信息区域 end -->

    <!-- 租赁统计图 start -->
    <van-row class="middle">
      <van-row class="label">客户租赁额统计图</van-row>
      <van-row class="charts-wrap">
        <div id="myChart" ref="myChart"></div>
      </van-row>
    </van-row>
    <!-- 租赁统计图 end -->

    <!-- 租赁利润分析 start  -->
    <div class="footer analyse">
      <div class="label">租赁利润分析</div>
      <van-row class="analyse-list" gutter="20" type="flex" justify="center">
        <van-col class="item" :span="12" v-for="(item, index) in analyseList" :key="index">
          <van-row gutter="0" type="flex" align="center">
            <van-col :span="4">
              <van-row class="label">
                <van-col>{{ item.label }}</van-col>
              </van-row>
            </van-col>
            <van-col :span="20">
              <van-row class="item-text">
                <van-col :span="24" v-for="(item1, index1) in item.list" :key="index1"
                  >{{ item1.text }}: <span class="golden">{{ item1.value }}</span></van-col
                >
              </van-row>
            </van-col>
          </van-row>
        </van-col>
      </van-row>
    </div>
    <!-- 租赁利润分析 end  -->

    <!-- 申请额度对话框 start -->
    <van-dialog
      v-model="creditUpDialogShow"
      className="creditUpDialog"
      title="需要申请的额度"
      show-cancel-button
      @confirm="submitCreditUp"
    >
      <!--  @focus.stop="showDatetimePickerHandle" -->
      <el-form label-width="100px">
        <el-form-item label="额度到期时间">
          <el-input v-model="currentDate" type="date" placeholder="点击选择时间"></el-input>
        </el-form-item>
        <el-form-item label="申请的额度">
          <el-input v-model="creditUpValue" placeholder="请输入要申请金额"></el-input>
        </el-form-item>
      </el-form>
    </van-dialog>
    <!-- 申请额度对话框 end -->

    <!-- 租赁详情对话框 start -->
    <van-dialog
      className="supplierDialog"
      v-model="supplierDialogShow"
      lockScroll
      theme="round-button"
      confirmButtonText="关 闭"
      confirmButtonColor="#51596e"
    >
      <van-row>
        <van-col :span="17"
          ><span class="name">{{ title.name }}</span></van-col
        >
        <van-col :span="7"
          ><span class="right bg-green">等级: {{ title.grade }}</span></van-col
        >
      </van-row>
      <van-row class="info-table">
        <van-row>
          <van-col :span="16"><span class="title">联系信息 </span></van-col>
          <van-col :span="8">
            <span class="right bg-blue">{{ title.type }}</span>
          </van-col>
        </van-row>
        <van-divider :style="{ borderColor: '#999', margin: '12px 0' }" />
        <van-row>
          <van-col class="tr" :span="24" v-for="(item, index) in list1" :key="index">
            <span class="text">{{ item.text }}:&nbsp;&nbsp;&nbsp;</span>
            <span class="value">{{ item.value }}</span>
          </van-col>
        </van-row>
      </van-row>
      <van-row class="info-table">
        <van-row>
          <van-col :span="16"><span class="title">付款信息 </span></van-col>
        </van-row>
        <van-divider :style="{ borderColor: '#999', margin: '12px 0' }" />
        <van-row>
          <van-col class="tr" :span="24" v-for="(item, index) in list2" :key="index">
            <span class="text">{{ item.text }}:&nbsp;&nbsp;&nbsp;</span>
            <span class="value">{{ item.value }}</span>
          </van-col>
        </van-row>
      </van-row>
    </van-dialog>
    <!-- 租赁详情对话框 end -->

    <!-- 本月应付账款  popup start -->
    <van-popup
      v-model="popupShow"
      :overlay="false"
      position="right"
      :style="{ width: '100%', height: '101%', background: '#f8f8f8' }"
    >
      <van-row class="popup-container">
        <van-row class="info">
          <van-row class="title">{{ title.name }}</van-row>
          <van-row>
            <van-col>本月应收账款</van-col>
            <van-col class="right "
              ><span class="green"> ￥{{ title.thismounthsubsist }}</span></van-col
            >
          </van-row>
          <van-divider :style="{ borderColor: '#999', margin: '12px 0' }" />
          <van-row class="card-wrap" gutter="20">
            <van-col :span="12">
              <van-row>
                <div>￥{{ listTitle.thismouthhavein }}</div>
                <div>本月已开票金额</div>
              </van-row>
            </van-col>
            <van-col :span="12">
              <van-row>
                <div>{{ listTitle.thismouthhaveinorder }}</div>
                <div>本月待收款订单量</div>
              </van-row>
            </van-col>
          </van-row>
        </van-row>

        <!-- 折叠列表区域 start -->
        <van-list
          v-model="loadingList"
          :finished="finished"
          :error.sync="error"
          error-text="点击重新加载"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <van-collapse class="collapseWrap" title-class="title-order" v-model="activeNames">
            <van-collapse-item
              class="item-wrap"
              :title="'订单号:' + item.orderid"
              :name="item.orderid"
              v-for="item in orderList"
              :key="item.orderId"
            >
              <van-row class="text">订单状态: {{ item.status }}</van-row>
              <van-row class="text">订单金额: {{ item.amount }}</van-row>
              <van-row class="text">本月待付款金额: {{ item.mouthpay }}</van-row>
              <van-row class="text">
                <van-row>附件:</van-row>
                <van-row type="flex" gutter="20">
                  <van-col span="8" v-for="(item, index) in item.file" :key="index">
                    <a :href="item">
                      <van-image
                        width="100"
                        height="100"
                        fit="contain"
                        :src="imgUrl + '/admin/ajax/icon?suffix=' + formatSuffix(item)"
                      />
                    </a>
                  </van-col>
                </van-row>
              </van-row>
            </van-collapse-item>
          </van-collapse>
        </van-list>
        <!-- 折叠列表区域 end -->
        <div class="fixed-bottom">
          <van-button class="closeBtn" round block @click="popupShow = false">关闭</van-button>
        </div>
      </van-row>
    </van-popup>
    <!-- 本月应付账款  popup end -->

    <van-popup v-model="datatimePickerShow" position="bottom" :style="{ height: '40%' }">
      <van-datetime-picker
        v-model="datePicker"
        type="date"
        title="选择年月日"
        :min-date="minDate"
        @cancel="datatimePickerShow = false"
        @confirm="datetimeConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
import { BASE_URL } from "../../../../config/global.js";
import echarts from "echarts";
import ArcProgress from "arc-progress";
import { formatDate } from "../../../../plugins/function.js";
export default {
  data() {
    return {
      loading: false,
      creditUpDialogShow: false,
      supplierDialogShow: false,
      popupShow: false,
      activeNames: ["1", "2", "3"],
      analyseList: [],
      title: {
        id: 0,
        name: "供应商全称",
        abbreviation: "供应商简称",
        grade: "未知",
        thismounthsubsist: 0,
        totalsubsist: 0,
        currency_amount: "0.00",
        type: "行业供应商",
        list1: [],
        list2: [],
        quota: 0,
        quota_total: 0,
        quota_switch: 0,
        temporary_quota: 0,
        have_used_quota: 0,
        can_use_quota: 0,
      },
      list1: [],
      list2: [],
      orderList: [],
      chartData: {},
      listTitle: {},
      creditUpValue: "", // 需要申请的额度
      page: 1,
      loadingList: false,
      finished: false,
      error: false,
      imgUrl: BASE_URL,
      progressValue: 0.68,
      moneyFontSize: "24px", // 可以额度字体大小 默认24px
      waveUrl: require("../../../../assets/images/wave.png"),
      datatimePickerShow: false,
      minDate: new Date(),
      currentDate: "",
      datePicker: "",
    };
  },
  methods: {
    /**
     * 初始化弧形进度条
     */
    initArcProgress() {
      this.$nextTick(() => {
        // 去掉千分位
        let haveUsedQuota = this.title.have_used_quota.toString();
        let quotaTotal = this.title.quota_total.toString();
        haveUsedQuota = haveUsedQuota.split(",").join("");
        quotaTotal = quotaTotal.split(",").join("");

        this.progressValue = (haveUsedQuota / quotaTotal).toFixed(2);
        let arcProgress = new ArcProgress({
          el: "#progress-container",
          progress: this.progressValue > 1 ? 1 : this.progressValue,
          speed: 50,
          value: "39.92",
          size: 150,
          thickness: 10,
          fillColor: "#fff",
          emptyColor: "#ffffff61",
        });
      });
    },
    /**
     * 根据可以余额大小设置字体大小
     */
    autoSetMoneyFontSize() {
      this.$nextTick(() => {
        const fsEnum = {
          3: "24px",
          4: "24px",
          5: "22px",
          7: "20px",
          8: "20px",
          9: "18px",
          10: "16px",
          12: "14px",
          13: "14px",
        };
        this.moneyFontSize = fsEnum[this.title.can_use_quota.length];
      });
    },

    /**
     * 获取供应商信息
     */
    async getSupplierInfo() {
      let params = {
        id: this.$route.params.id,
      };
      let toast = this.$toast.loading({
        message: "加载中...",
      });
      let { data } = await this.$post(this.$api.stGetLeaseCustomerInfo, params);
      this.title = data.title;
      this.analyseList = data.box;
      this.listTitle = data.list_title;
      this.chartData = data.year.lists;
      this.list1 = data.title.list1;
      this.list2 = data.title.list2;

      this.echartInit();
      this.initArcProgress();
      this.autoSetMoneyFontSize();
      toast.clear();
    },
    /**
     * 初始化echarts
     */
    echartInit() {
      this.$nextTick(() => {
        var myChart = echarts.init(this.$refs.myChart);
        myChart.setOption({
          // title: { text: "会员趋势" },
          tooltip: { trigger: "axis" },
          color: ["#2a82e4"],
          grid: {
            left: "20px",
            right: "20px",
            top: "10px",
            bottom: "30px",
            containcolor_3: true,
          },
          // toolbox: { feature: { saveAsImage: {} } },
          xAxis: {
            type: "category",
            boundaryGap: false,
            data: this.chartData.dates,
          },
          yAxis: [
            {
              name: "租赁额",
              type: "value",
              axisLabel: {
                formatter: function() {
                  return "";
                },
              },
            },
          ],
          series: [
            {
              name: "金额(CNY)",
              type: "line",
              data: this.chartData.price,
              yAxisIndex: 0,
              smooth: true,
            },
          ],
        });
      });
    },
    /**
     * 显示申请额度对话框
     */
    showCreditUpHandle() {
      this.creditUpValue = "";
      this.creditUpDialogShow = true;
    },
    /**
     * 获取供应商详细信息
     */
    showSupplierInofHandle() {
      this.supplierDialogShow = true;
    },

    showPopupHandle() {
      this.popupShow = true;
    },

    /**
     * 提交申请额度表单
     */
    async submitCreditUp() {
      let id = this.$route.params.id;
      let money = this.creditUpValue.trim();
      let quota_expire_time = +new Date(this.currentDate);
      if (!money.includes(".")) {
        money = money + ".00";
      }
      const reg = /^\d+(\.\d{1,2}?$)/;
      if (!reg.test(money)) {
        this.$toast.fail("请输入正确的金额");
        return;
      }
      if (Object.is(quota_expire_time, NaN)) {
        this.$toast.fail("时间不能为空");
        return;
      }

      let params = { id, money, quota_expire_time };
      await this.$post(this.$api.stGetCreditUp, params);
      this.currentDate = "";
      this.$toast.success("已提交申请,请关注飞书审批.");
    },

    async onLoad() {
      let params = {
        id: this.$route.params.id,
        page: this.page,
      };

      try {
        let { data } = await this.$post(this.$api.stGetLeaseCustomerOrderList, params);
        // 若数据已全部加载完毕
        if (data.length == 0) {
          this.finished = true;
        }
        if (this.page == 1) {
          this.orderList = [];
        }
        this.orderList.push(...data);
        this.page++;
      } catch (error) {
        console.log(error);
        this.error = true;
      } finally {
        this.loadingList = false;
      }
    },
    formatSuffix(url) {
      let arr = url.split("/");
      let filename = arr[arr.length - 1];
      arr = filename.split(".");
      let suffix = arr[arr.length - 1];
      return suffix;
    },
    /**
     * 显示时间选择器
     */
    showDatetimePickerHandle() {
      this.datatimePickerShow = true;
    },
    /**
     * 选择时间
     */
    datetimeConfirm(value) {
      this.currentDate = formatDate(value, "yyyy-MM-dd");
      this.datatimePickerShow = false;
    },
  },
  mounted() {
    this.getSupplierInfo();
    window.h5sdk.ready(function() {
      window.h5sdk.biz.navigation.setTitle({ title: "客户统计" });
    });
  },
};
</script>

<style lang="scss" scoped>
$yellow: #ff8d1a;
$gary: #a6a6a6;
$golden: #a96929;
$green: #00baad;
$blue: #2a82e4;
.yellow {
  color: $yellow;
}
.gary {
  color: $gary;
}
.golden {
  color: $golden;
}
.green {
  color: $green;
}
.bg-green {
  background-color: $green;
}
.bg-blue {
  background-color: $blue;
}
.ft-12 {
  font-size: 12px;
  color: #505050;
}
.main-wrap {
  background-color: #f6f4f2;

  .customerCredit-x {
    position: relative;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-top: 10px;
    // background-color: #fe4d3c; f95557
    background: linear-gradient(225deg, #fe4d3c, #f95557);

    #progress-container {
      position: relative;

      .progress-detail {
        position: absolute;
        top: 50%;
        left: 50%;
        text-align: center;
        color: #fff;
        transform: translate(-50%, -30%);

        .money {
          line-height: 24px;
          // font-size: 24px;
        }
        .van-divider {
          margin: 6px 0;
        }
        .label {
          color: #e0e0e0;
        }
        .title {
          display: inline-block;
          margin: 10px auto 0;
          font-size: 18px;
          &::before {
            content: "";
            display: block;
            position: relative;
            top: 14px;
            left: -18px;
            width: 10px;
            height: 0;
            border: 1px solid #fff;
          }
          &::after {
            content: "";
            display: block;
            position: relative;
            top: -14px;
            left: 78px;
            width: 10px;
            height: 0;
            border: 1px solid #fff;
          }
        }
      }
    }
    .credit-detail-x {
      position: relative;
      width: 100%;
      height: 80px;

      .wave-img {
        position: absolute;
        width: 100%;
        height: 100%;
      }
      .credit-li {
        position: relative;
        z-index: 1;

        .credit-ul {
          margin-top: 30px;
          text-align: center;
        }
        .credit-ul + .credit-ul {
          border-left: 1px solid #e0e0e0;
        }
      }
    }
    .credit-up {
      position: absolute;
      top: 10px;
      right: 20px;
      color: #e7e7e7;
      // z-index: 1;
    }
  }

  .header-info {
    box-sizing: border-box;
    position: relative;
    padding: 15px 15px 0;
    background: linear-gradient(180deg, #fff 170px, #fff 170px, transparent);

    .header-bg {
      position: absolute;
      top: 0;
      right: 0;
      width: 302px;
      height: 170px;
      background: url("../../../../assets/images/bg_header.png") no-repeat top right/302px 170px;
      z-index: 0;
    }

    .container {
      position: relative;
      z-index: 1;

      .top {
        padding-top: 16px;
        color: #505050;
        .abbreviation {
          font-size: 18px;
        }
        .fullName {
          font-size: 12px;
        }
        .bt-info {
          margin-top: 20px;
        }
      }

      .bottom {
        margin-top: 16px;
        padding: 6px;
        background-color: rgba(255, 255, 255, 0.9);
        border-radius: 5px;
        box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.03), 1px -1px 4px rgba(0, 0, 0, 0.03), -1px -1px 4px rgba(0, 0, 0, 0.03),
          -1px 1px 4px rgba(0, 0, 0, 0.03);

        .card-wrap {
          padding: 8px;
          text-align: center;

          .label {
            margin-top: 8px;
            font-size: 12px;
          }
        }
      }
    }
  }

  .middle {
    padding: 15px;
    .label {
      font-size: 12px;
      color: $gary;
    }

    .charts-wrap {
      margin-top: 8px;
      border-radius: 8px;
      background-color: #fff;

      #myChart {
        width: 100%;
        height: 40vw;
      }
    }
  }

  .footer {
    padding: 15px;
    .label {
      font-size: 12px;
      color: $gary;
    }

    .analyse-list {
      margin-top: 8px;

      .item > .van-row {
        flex-direction: row;
        margin-bottom: 8px;
        padding: 8px;
        font-size: 12px;
        background-color: #fff;
        border-radius: 5px;
        box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.185);

        .label {
          color: $golden;
          width: 24px;
          font-size: 12px;
        }
        .item-text {
          margin-left: 8px;
          .van-col {
            margin: 2px 0;
          }
        }
      }
    }
  }

  .creditUpDialog {
    padding: 0 20px;
    .el-form {
      margin-top: 10px;
      ::v-deep .el-input.is-disabled .el-input__inner {
        background-color: #fff;
      }
    }
  }

  .supplierDialog {
    box-sizing: border-box;
    padding: 12px 20px 0;
    max-height: 80%;
    overflow-y: scroll;

    .van-row {
      margin: 4px 0;
      .name {
        position: relative;
      }
      .name::before {
        content: "";
        position: absolute;
        left: -6px;
        width: 0;
        height: 100%;
        border: 1px solid #00baad;
      }

      .right {
        float: right;
        padding: 4px 12px;
        font-size: 12px;
        color: #fff;
        border-radius: 16px;
      }
    }

    .info-table {
      margin-top: 18px;
      font-size: 12px;

      .title {
        color: #505050;
        font-weight: 500;
        font-size: 13px;
      }

      .tr {
        line-height: 2;
      }
    }
  }

  .popup-container {
    box-sizing: border-box;
    position: relative;
    padding: 16px 16px 80px;
    height: 100%;
    font-size: 12px;
    color: #505050;
    overflow: scroll;

    .right {
      float: right;
    }
    .fixed-bottom {
      box-sizing: border-box;
      position: fixed;
      padding: 0 20px;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 60px;
      background-color: #f8f8f8;

      .closeBtn {
        margin-top: 6px;
        text-align: center;
        letter-spacing: 8px;
        color: #fff;
        background-color: #51596e;
      }
    }

    .info {
      padding: 10px;
      .title {
        position: relative;
        font-size: 14px;
        margin-bottom: 10px;

        &::before {
          content: "";
          position: absolute;
          top: 0;
          left: -4px;
          width: 0;
          height: 100%;
          border: 1px solid $green;
        }
      }

      .card-wrap {
        text-align: center;
        .van-col:nth-child(1) .van-row {
          padding: 6px;
          border-radius: 5px;
          background-color: $green;
        }
        .van-col:nth-child(2) .van-row {
          padding: 6px;
          border-radius: 5px;
          background-color: $blue;
        }
        .van-col div {
          padding: 4px 0 4px;
          color: #fff;
        }
      }
    }

    .collapseWrap {
      .item-wrap {
        margin: 16px 0;

        .text {
          line-height: 2;
          font-size: 12px;
          color: #505050;
        }
      }
      ::v-deep.van-cell__title {
        font-size: 12px;
        color: #505050;
      }
    }
  }
}
</style>
